module.exports = __webpack_public_path__ + "img/occupation.cacac3f9.jpg";